module.exports = __webpack_public_path__ + "img/service-xindai1.79b436ff.svg";